<template>
    <div class="title_box">
        {{ title }}
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
    },
};
</script>
<style scoped>
.title_box {
    line-height: 66px;
    font-size: 24px;
    color: #000;
    text-align: center;
}
</style>
